<template>
  <div class="px-4 py-3 day-modal">
    <!-- Diff -->
    <div
      class="text-xl font-medium capitalize text-base-900"
      data-testid="date-text"
    >
      {{ dayData.texts.date }}
    </div>

    <LpCard
      v-if="!currentPermissions.calendar"
      class="flex items-center bg-grape-100 text-grape-500 shadow-none p-4 mt-2 gap-4 font-normal"
    >
      {{ $t('This data belongs to a demo hotel. Upgrade your BenchDirect plan to see your property\'s data.') }}
      <UpgradeBtn section="calendar" />
    </LpCard>

    <!-- Bar chart -->
    <div class="mt-4 day-modal__chart-wrapper">
      <!-- title -->
      <div
        class="day-modal__chart-title"
        data-testid="barcharttitle-text"
      >
        {{ dayData.texts.barChartTitle }}
      </div>
      <!-- diff text -->
      <div
        :class="[
          'day-modal__diff-el text-sm mt-2 mb-4',
          dayData.diffClass,
        ]"
        data-testid="comparedto-text"
      >
        <span class="text-xl">
          {{ dayData.texts.diffTextValue }}
        </span>
        {{ dayData.texts.comparedTo }}
      </div>
      <ChartView
        :id="`calendar-bar-chart-date-${dayData.dateTs}`"
        :spec="barChartConfig.spec"
        :currency="barChartConfig.currency"
        :disable-hover="true"
      />
    </div>

    <div
      v-if="dayData.minSize !== dayData.maxSize"
      class="mt-4 day-modal__chart-wrapper"
    >
      <MetricDescriptionBox
        :metric="dayData.texts.sizeMetric"
        :tp-config="dayData.texts.tpConfig"
        text-size="lg"
        data-testid="sizemetric-text"
      />
      <ChartView
        :id="`calendar-size-indicator-chart-date-${dayData.dateTs}`"
        :spec="sizeIndicatorChartConfig.spec"
        :currency="sizeIndicatorChartConfig.currency"
        :disable-hover="true"
      />
    </div>
  </div>
</template>

<script>
import ChartView from '@/modules/DataSections/components/Chart/ChartView.vue';
import MetricDescriptionBox from '@/components/MetricDescriptionBox/MetricDescriptionBox.vue';
import UpgradeBtn from '@/components/UpgradeBtn/UpgradeBtn.vue';
import useSectionState from '@/state/useSectionState';

export default {
  name: 'DayInfoModal',
  components: {
    ChartView,
    MetricDescriptionBox,
    UpgradeBtn,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        dayData: {
          texts: {},
        },
        barChartConfig: {},
        sizeIndicatorChartConfig: {},
      }),
    },
  },
  setup(props) {
    const { currentPermissions } = useSectionState();

    return {
      dayData: props.data.dayData,
      barChartConfig: props.data.barChartConfig,
      sizeIndicatorChartConfig: props.data.sizeIndicatorChartConfig,
      currentPermissions,
    };
  },
};
</script>

<style scoped>
.day-modal {
  width: 32rem;
}
.day-modal__chart-wrapper {
  @apply rounded-xl;
  @apply p-6;
  @apply border;
  @apply border-base-500;
}
.day-modal__diff-el.negative {
    @apply text-danger-500;
}
.day-modal__diff-el.positive {
    @apply text-success-500;
  }
.day-modal__chart-title {
  @apply text-lg;
  @apply font-medium;
  @apply text-base-900;
}
.chart-wrapper {
  &:hover {
    @apply border-base-400 shadow-none;
  }
}
</style>
